/**
 * A escada de camadas da interface (z-index), em um lugar só.
 *
 * **Por que este arquivo existe.** O N-1 (achado do Matheus, 2026-07-31): ao
 * criar proposta sem preencher a próxima ação, a mensagem de erro aparecia
 * ATRÁS do modal — o formulário parecia travar sem motivo. A causa não era o
 * modal nem o toast: era não haver escada. O `Toast` carregava o comentário
 * *"z-50 pra ficar acima de Dialog (z-30)"*, mas o `Dialog` tinha virado z-50
 * em algum momento e ninguém atualizou o outro lado. Empatados, quem renderiza
 * por último vence — e o Dialog usa portal, então renderiza depois.
 *
 * Número mágico espalhado por arquivo não sobrevive a duas rodadas. A regra
 * daqui pra frente:
 *
 *   1. **camada nova se declara aqui**, com um nome que diz o papel;
 *   2. quem precisa ficar acima de algo **usa a constante**, não um número;
 *   3. o espaçamento é de 10 em 10 de propósito — cabe um andar no meio sem
 *      renumerar o prédio.
 *
 * A ordem não é arbitrária, ela responde a uma pergunta: *o que precisa ser
 * visto mesmo quando tudo o mais está aberto?* A resposta é sempre a mensagem
 * ao usuário. Por isso `AVISO` é o topo — acima até do diálogo que a disparou.
 */
export const CAMADA = {
  /** Conteúdo fixo da página (cabeçalho de tabela grudento, barra de ações). */
  GRUDENTO: 20,
  /** Casca do app: sidebar, topbar. */
  CASCA: 30,
  /** Menu suspenso, combobox, popover — ancorado em algo da página. */
  SUSPENSO: 40,
  /** Diálogo e seu fundo escuro. Bloqueia a página inteira. */
  DIALOGO: 50,
  /**
   * Popover ancorado que pode viver DENTRO de um diálogo (Calendario, seletor
   * com painel). Acima do DIALOGO — senão o próprio modal o cobre — e abaixo
   * da DICA e do AVISO, que explicam/avisam sobre ele.
   */
  FLUTUANTE: 60,
  /** Dica de ajuda ("?"). Acima do diálogo porque existe DENTRO dele. */
  DICA: 90,
  /**
   * Aviso ao usuário: toast, erro de validação, aviso de atualização do PWA.
   * **O topo da escada, e é onde tem que ficar** — um erro que o usuário não
   * consegue ler é pior do que erro nenhum, porque a tela parece quebrada.
   */
  AVISO: 100,
} as const;

/** Classe Tailwind da camada (arbitrary value — o Tailwind não gera z-100). */
export const classeCamada = (c: number) => `z-[${c}]`;
